import React, { useContext } from 'react';
import { signUpContext } from '../../../pages/signup';
import  './ChooseClient.css';
import Button from '../../../components/ui/BlueButton';

const ChooseClient = () => {
    const { Page, setPage, setNext } = useContext(signUpContext);
    const boxStyle = {
      position: 'absolute',
      width: '50%',
      height: '100%',
      top: '0',
      left: '0',
      borderRadius: '5px',
      backgroundColor: '#E7EEFF',
      transform: Page==='seeker' ? 'translateX(100%)' : 'translateX(0)',
      transition: 'transform 0.5s',
      mixBlendMode: 'color',
      cursor: 'pointer',
    };
  
    const groupStyle = {
      position: 'relative',
      width: '80%',
      margin: '1rem',
      padding: '1rem',
      display: 'flex',
      justifyContent: 'space-between',
      border: '1px solid grey',
      borderRadius: '10px',
      overflow: 'hidden',
      cursor: 'pointer',
      boxSizing: 'border-box',
    };
  
    const optionStyle = {
      flex: '1 1 50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#03236F',
      cursor: 'ponter',
    };
    const groupStyle2 = {
      width: '80%',
      margin: '1rem',
      padding: '2rem',
      paddingLeft: '3rem',
      paddingRight: '3rem',
      display: 'flex',
      border: '1px solid grey',
      borderRadius: '10px',
      overflow: 'hidden',
      cursor: 'pointer',
      flexDirection: 'column',
      boxSizing: 'border-box',
    }
      return (
        <>
            <h1>Join Jobbwork as</h1>
            <div style={groupStyle}>
              <div style={boxStyle} />
              <div style={optionStyle} onClick={() => setPage('poster')}>I'm a project poster</div>
              <div style={optionStyle} onClick={() => setPage('seeker')}>I'm a project seeker</div>
            </div>
            <div style={groupStyle2}>
              {Page === 'seeker' ? (<>
              <p style={{fontSize: '1.5rem'}}>Register as a Project Poster to </p><ul style={{fontSize: '1rem'}}>
              <li>Attractive candidate pool with compelling business profiles.</li>
              <li>Clearly define project details in job posts, including scope and requirements.</li>
              <li>Efficient candidate communication</li></ul>
              </>) : (
              <>
              <p style={{fontSize: '1.5rem'}}>Register as a Project Seeker to </p><ul style={{fontSize: '1rem'}}>
              <li>Access an attractive pool of candidates with compelling business profiles.</li>
              <li>Clearly define project details in your applications, including scope and requirements.</li>
              <li>Communicate efficiently with potential project posters.</li></ul>
              </>)}
            </div>
            <Button extraStyle={{width: '80%'}} onClick={() => setNext(1)}><p>Next</p></Button>

        </>
      )
  }

  export default ChooseClient;